export const locale = {
	lang: 'es_ES',
	data: {
		en_EN: 'EN',
		fr_FR: 'FR',
		es_ES: 'ES',
		pt_PT: 'PT',
		
		welcome: 'Bienvenido',
		hello: 'Hola',
		insert_email_login: 'Introduce el correo electrónico para iniciar sesión',
		insert_phone_login: 'Introduce el número de teléfono para iniciar sesión',
		next: 'Siguiente',
		auth_phone: 'O autentíquese por teléfono',
		auth_email: "O autentíquese por correo electrónico",
		no_account_login: '¿No tienes una cuenta?',
		register: 'Registrarse',
		entry_catchphrase: '¿No tienes cambio? Déjalo con nosotros',
		sign_in: "Iniciar sesión",
		full_name: "Nombre completo",
		email: 'Email',
		phone_number: "Número de teléfono",
		already_have_account: "¿Ya tienes una cuenta?",
		confirmation_code_title: 'Código de confirmación',
		confirmation_code_instruction_email: 'Ingrese el código de confirmación recibido en su correo electrónico para iniciar sesión',
		confirmation_code_instruction_phone: 'Ingrese el código de confirmación recibido por SMS en su teléfono para iniciar sesión',
		code_did_not_recieve: '¿No recibiste el código?',
		code_resend: 'Reenviar código',

		code_sent_success_email: 'Code de confirmation envoyé à votre e-mail.',
		code_sent_success_sms: 'Code de confirmation envoyé à votre téléphone.',
		code_resend_info: 'Code de confirmation renvoyé.',
		code_resend_error: 'Une erreur s\'est produite lors du renvoi du code de confirmation. Veuillez réessayer.',
		code_confirm_no_cred: 'Aucune information d\'identification fournie pour la confirmation.',
		code_confirm_error: 'Une erreur s\'est produite lors de la confirmation du code. Veuillez réessayer.',
		code_confirm_invalid_error: 'Le code saisi est incorrect.',

		login: 'Iniciar sesión',
		not_received_code: '¿No recibió el código?',
		resend_code: 'Reenviar',
		or_authenticate: 'O autentíquese',
		via_phone: 'vía teléfono',
		via_email: "vía correo electrónico",
		confirm: "Confirmar",
		invalid_field: "Campo inválido",
		field_required: "Este campo es obligatorio",
		field_too_short: "El campo es demasiado corto",
		field_too_long: "El campo es demasiado largo",
		field_invalid_email: "Formato de correo electrónico inválido",
		field_invalid_phone: "Formato de número de teléfono inválido",
		with_another_method: "con otro método",
		wrong_code: "El código que ingresaste es incorrecto",
		remaining_attempt: "Intentos restantes: ",

		movements: 'Movimientos',
		use_balance: 'Usar',
		back_to_top: 'Volver arriba',
		
		login_error: 'Error de inicio de sesión. Por favor, inténtelo de nuevo.',
		login_invalid_error: 'Credenciales de inicio de sesión inválidas. Por favor, verifique su información.',
		login_user_not_found_error: 'Usuario no encontrado. Por favor, verifique su información.',
		signup_error: 'Error de registro. Por favor, inténtelo de nuevo.',
		signup_user_already_exists_error: 'El número de teléfono ya existe. Por favor, use un número diferente o inicie sesión.',
		signup_invalid_error: 'Datos de registro inválidos. Por favor, verifique su información.',

		location_not_authorized_warning: 'Acceso a la ubicación no autorizado. Por favor, active los permisos de ubicación para encontrar puntos de venta cercanos.',

		points_of_sale_error: 'Error al cargar puntos de venta cercanos. Por favor, inténtelo de nuevo.',
		
		session_expired_error: 'Sesión expirada. Por favor, inicie sesión nuevamente.',

		no_options_select: 'No hay opciones disponibles',
		select_country: 'Seleccionar país',
		
		page_not_found: 'Página no encontrada',
		page_not_found_description: 'La página que buscas no existe o ha ocurrido otro error.',
		return:'Regresar',

		balance: 'Saldo',
		add_balance: 'Agregar saldo',
		add_card: 'Agregar tarjeta',

		read_qr_code: 'Leer código QR',
		read_qr_code_instructions: 'Acerca tu smartphone a la máquina para leer el código QR.',
		add_physical_card: 'Añadir tarjeta física',
		pass_card: 'Pasar tarjeta',
		pass_card_instructions: 'Pasa tu tarjeta física por el lector de la máquina para continuar.',
		confirm_card: 'Confirmar tarjeta',
		confirm_card_instructions: 'Pasa nuevamente la tarjeta por el lector de la máquina para confirmar tus datos.',
		finish_card: 'Tarjeta añadida',
		add_another_card: 'Añadir otra tarjeta',
		finish: 'Finalizado',
		finish_card_instructions: 'Tu tarjeta ha sido añadida exitosamente a tu billetera digital. Verifica que el código de arriba coincida con el número de tu tarjeta.',
		cancel: 'Cancelar',

		subdomain_not_found: 'No se encontró subdominio o subdominio inválido',
		subdomain_not_found_description: 'No se pudo encontrar un subdominio válido, la URL insertada debe contener un subdominio válido.',
		balance_use: 'Usar saldo',
		balance_use_page_title: 'Define el importe que se va a utilizar',
		available_balance: 'Saldo disponible',
		approve_use: 'Aprueba para continuar con la operación',
		add_to_machine: 'Añadir crédito',

		amount_too_low: 'El importe introducido es demasiado bajo',
		amount_too_high: 'El importe introducido es demasiado alto',

		identify_machine: 'Identificar máquina',
		scan_qr_code: 'Escanear código QR',
		machine_code: 'Código de la máquina',
		insert_code: 'Introducir código',
		
		toast_error_invalid_machine: 'El código de la máquina no es válido o la tarjeta seleccionada no puede utilizarse en la máquina.',

		credit_sent: 'Crédito enviado',
		transaction_approved: 'Transacción aprobada',
		go_to_home: 'Página principal',

		toast_error_transaction_get_error: 'Se produjo un error al obtener las transacciones.',

		add_card_description: '¿Qué tipo de tarjeta te gustaría añadir?',
		add_virtual_card: 'Añadir tarjeta virtual',
		
		scan_qrcode: 'Escanear código QR',
		error_no_camera_found: 'No se ha encontrado ninguna cámara. Asegúrate de que tu dispositivo tenga una cámara y de que los permisos necesarios estén concedidos.',
		toast_info_camera_permission_required: 'Se requiere permiso de cámara para escanear códigos QR. Por favor, habilita el acceso a la cámara en la configuración de tu dispositivo.',
		toast_error_no_camera_found: 'No se ha encontrado ninguna cámara. Asegúrate de que tu dispositivo tenga una cámara y de que los permisos necesarios estén concedidos.',
		
		toast_error_verifying_card: 'Se produjo un error al verificar la tarjeta.',
		toast_error_scanning_card: 'Se produjo un error al escanear la tarjeta. Por favor, inténtalo de nuevo.',

		go_to_cards: 'Ir a mis tarjetas',

		or_insert_code: 'o introducir código',

		promos: 'Reglas',
		promo: 'Regla',

		toast_error_fetching_cards: 'Se produjo un error al recuperar tus tarjetas.',

		sign_out: 'Cerrar sesión',
		dialog_signout: '¿Deseas cerrar sesión en tu cuenta?',
		
		toast_pwa_get_error: 'Se produjo un error al obtener la cartera.',
		home_find_wallet: 'Encuentra tu billetera de fidelización',
		loyalty_wallet_recents: 'Billeteras de fidelización recientes',
		home_insert_code: 'Introducir código',
		or: 'o',

		toast_error_getting_pwas: 'Se produjo un error al recuperar tus billeteras más recientes.',

		select_recent_machines: 'Selecciona máquinas recientes',

		forgot_password: '¿Olvidaste tu contraseña?',
		email_input: 'Correo electrónico',
		password_input: 'Contraseña',
		login_wallet: 'Iniciar sesión',
		login_wallet_description: 'Introduce tu correo electrónico y contraseña para usar tu Wallet',
		login_button: 'Iniciar sesión',
		login_no_account: '¿No tienes cuenta?',
		login_register: 'Crear una cuenta',
		confirm_password_input: 'Confirmar contraseña',
		signup_wallet_already_have_account: '¿Ya tienes una cuenta?',
		signup_login: 'Iniciar sesión',
		signup_wallet: 'Registrarse',
		signup_wallet_description: 'Crea tu cuenta.',
		signup_button: 'Registrarse',
		reset_password: 'Restablecer contraseña',
		reset_password_description: 'Restablece tu contraseña introduciendo tu correo electrónico',
		reset_password_button: 'Restablecer contraseña',
		reset_login: 'Iniciar sesión',
		reset_password_verified_email: 'Si tu correo electrónico está registrado, recibirás un correo para restablecer tu contraseña.',

		toast_signup_email_sent: 'Se ha enviado un correo electrónico para verificar tu cuenta.',
		toast_success_reset_password: 'Si tienes una cuenta, te hemos enviado un correo electrónico con más instrucciones.',

		error_email_invalid: 'El correo electrónico no es válido.',
		error_email_required: 'El correo electrónico es obligatorio.',

		error_password_required: 'La contraseña es obligatoria.',
		error_password_too_short: 'La contraseña es demasiado corta.',
		error_password_mismatch: 'Las contraseñas deben coincidir.',

		toast_error_login_invalid: 'Correo electrónico o contraseña incorrectos.',

		server_unreachable: 'No se puede conectar con el servidor. Por favor, comprueba tu conexión e inténtalo de nuevo.',
	},
};